import styled from "styled-components";
import Exit from "../../../assets/icons/exit.svg";
import LoadingButton from "../../loadingButton/loadingButton.component";

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background: #3b3b3be3;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 2rem;
  transition: opacity 0.2s ease-in-out;
`;
export const Form = styled.form`
  width: 700px;
  @media (max-height: 1200px) {
    height: 800px;
  }

  @media (max-height: 1000px) {
    height: 600px;
    bottom: 1rem;
  }

  @media (max-height: 800px) {
    height: 400px;
    bottom: 1rem;
  }

  @media (max-height: 600px) {
    height: 200px;
    bottom: 1rem;
  }

  @media (max-width: 768px) {
    width: 90vw;
    height: 90vh;
  }

  background-color: white;
  position: relative;
  box-shadow: 0px 2px 14px 15px rgba(102, 167, 196, 0.07);
  padding: 2rem;
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;
`;

export const FormHeader = styled.h1`
  margin-bottom: 3rem;
`;
export const ExitButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
`;
export const ExitIcon = styled.img.attrs({ src: Exit })`
  width: 20px;
  height: 20px;
`;
export const InputsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
export const InputsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;
export const Label = styled.label`
  font-size: 1rem;
  font-weight: 500;
`;
export const Input = styled.input`
  border-radius: 4px;
  height: 40px;
  border: 1px solid ${({ theme: { colors } }) => colors.gray200};
  max-width: 100%;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 3rem;
  margin-top: 2rem;
  align-items: center;
`;
export const FormButton = styled.button`
  display: grid;
  place-content: center;
  width: 50%;
  padding: 0.5rem 0;
  font-size: 1.2rem;
`;
export const AddButton = styled(LoadingButton)`
  /* background-color: ${({ theme: { colors } }) => colors.ceruleanFrost};
  color: ${({ theme: { colors } }) => colors.white}; */
  color: var(--text-color);
  background-color: var(--secondary-item-background-color);
  width: 50%;
  padding: 0.3rem 0;
  place-content: center;
  font-size: 1.2rem;
  height: 46px;
  border-radius: 8px;
`;
export const CancelButton = styled(FormButton)`
  height: 46px;
  border-radius: 8px;
  background-color: transparent;
  border: 2px solid ${({ theme: { colors } }) => colors.ceruleanFrost};
`;
export const DeleteButton = styled(LoadingButton)`
  background-color: rgba(255, 0, 0, 1);
  color: ${({ theme: { colors } }) => colors.white};
  width: 50%;
  padding: 0.5rem 0;
  place-content: center;
  font-size: 1.2rem;
  height: 56px;
  margin: 0 auto;
  margin-top: 1.5rem;
`;
export const SelectStatus = styled.select`
  border-radius: 4px;
  border: 1px solid ${({ theme: { colors } }) => colors.gray200};
  height: 40px;
  width: 25%;
  width: 100%;
  height: 38px;
  padding: 0.2rem;
`;
